export class Mutations {
  createProject = `mutation createProject($project_name:String!,$project_status:String! $start_date: AWSDate!, $end_date: AWSDate!,
        $client:String!,  $createdUserToken: ID!,$org_id: ID!, $project_lead: String!, $active: Int!, $projectType: String!) {
       createProject(input:{
         project_name:$project_name
         project_status:$project_status
         start_date: $start_date
         end_date: $end_date
         client: $client
         created_by: $createdUserToken
         org_id: $org_id
         project_lead:$project_lead
         active: $active
         projectType: $projectType
       }){
          project_id
          project_name
          project_status
       }
   }`;

  updateProject = `mutation updateProject($project_id : ID!, $project_name: String!, $project_status: String!, $start_date:AWSDate!,
        $end_date:AWSDate!, $client:String!,$createdUserToken: ID!,$org_id: ID!, $project_lead: String!, $active: Int!, $projectType: String!){
       updateProject(input:{
           project_id: $project_id
           project_name: $project_name
           project_status:$project_status
           start_date:  $start_date
           end_date:  $end_date
           client:  $client
           org_id: $org_id
           created_by:$createdUserToken
           project_lead: $project_lead
           active: $active
           projectType: $projectType
         }){
         project_id
         project_name
       }
     }`;

  deleteProject = ` mutation deleteProject($projectId: ID!) {
         deleteProject(
           project_id : $projectId
         ){
           project_id
           project_name
           status
         }
     } `;

  createTeam = `mutation createTeam($team_name: String!, $createdUserToken: ID!, $envId: ID!, $admin: String!) {
       createTeam(input: {
         team_name: $team_name
         administrator: $admin
         created_by: $createdUserToken
         org_id: $envId
       }) {
         team_id
         team_name
       }
     }`;

  updateTeam = `mutation updateTeam($team_id: ID!, $team_name: String!, $createdUserToken: String, $envId: ID!, $team_lead: String!){
       updateTeam(input:{
           team_id: $team_id
           team_name: $team_name
           team_lead: $team_lead
           org_id:$envId
           created_by: $createdUserToken
         }){
         team_id
         team_name
       }
     }`;

  deleteTeam = `mutation deleteTeam($teamId: ID!) {
             deleteTeam(
               team_id : $teamId
             ){
               team_id
               team_name
               status
             }
         } `;

  assignTeamToProject = `mutation assignTeamToProject($data: [ProjectTeamUserRelation]){
       assignTeamToProject(input:{
         data: $data
       }) {
        id
      }
     }`;

  updateTeamToProject = `mutation updateTeamToProject($data: [ProjectTeamUserRelation]){
       updateTeamToProject(input: {
         data: $data
       }) {
        response
      }
     }`;

  assignUsersToTeam = `mutation assignUsersToTeam($data: [ProjectTeamUserRelation]) {
       assignUsersToTeam(input: {
         data: $data
       }) {
         id
       }
     }`;

  updateUserToTeam = `mutation updateUsersToTeam($data: [ProjectTeamUserRelation]){
       updateUsersToTeam(input: {
         data: $data
       }) {
        response
      }
     }`;

  createWorkshop = `mutation createWorkshop($workshop_name: String!, $start_date: AWSDate!, $end_date: AWSDate!,
         $createdUserToken: ID!,$attendee_count:ID!, $agenda: String!, $org_id: ID!, $workshop_type: ID ){
           createWorkshop(input: {
           workshop_name: $workshop_name
           start_date: $start_date
           end_date: $end_date
           created_by: $createdUserToken
           attendee_count: $attendee_count
           agenda: $agenda
           org_id: $org_id
           workshop_type: $workshop_type
         }) {
           workshop_id
          workshop_name
         }
       }`;

  updateWorkshop = `mutation updateWorkshop($workshopId: ID!,$workshopName: String!,$startDate: AWSDate!, $endDate:AWSDate!,
       $createdUserToken:  String!, $attendeeCount:ID!, $agenda: String!, $orgId: ID!, $status: ID){
       updateWorkshop(input:{
           workshop_id: $workshopId
           workshop_name: $workshopName
           start_date: $startDate
           end_date: $endDate
           status: $status
           created_by: $createdUserToken
           attendee_count: $attendeeCount
           agenda: $agenda
           org_id: $orgId
         }){
         workshop_id
         workshop_name
       }
     }`;

  deleteWorkshop = `mutation deleteWorkshop($workshopId: ID!) {
       deleteWorkshop(
          workshop_id : $workshopId
       ){
       workshop_id
     workshop_name
       status
       }
   } `;

  createWorkshopActivity = `mutation createWorkshopActivity( $startTime: AWSTime, $endTime: AWSTime,
               $activityDescription: String!, $workshopId: ID!, $createdUserToken:ID!, $workshopDay:AWSDate!, $duration: ID!,
                $activityTag: ID!, $status: ID, $actual_start_time: AWSTime, $actual_end_time: AWSTime){
     createWorkshopActivity(input: {
       start_time:$startTime
       end_time: $endTime
       actual_start_time: $actual_start_time
       actual_end_time: $actual_end_time
       activity_description:$activityDescription
       workshop_id: $workshopId
       created_by: $createdUserToken
       workshop_day : $workshopDay
       duration: $duration
       activity_tag: $activityTag
       status: $status
     }) {
       activity_id
     }
   }`;

  deleteWorkshopActivity = `mutation deleteWorkshopActivity($activity_id: ID!) {
     deleteWorkshopActivity(
        activity_id : $activity_id
     ){
      activity_id
      status
     }
 }`;

  updateWorkshopActivity = `mutation updateWorkshopActivity($start_time: AWSTime!, $end_time: AWSTime!,$activity_description: String!,
   $workshop_id: ID!, $createdUserToken: ID!,$workshop_day: AWSDate!, $duration:ID!, $activity_id: ID!,
   $activity_tag: ID!, $status: ID!, $actual_start_time: AWSTime, $actual_end_time: AWSTime){
   updateWorkshopActivity(input: {
     start_time: $start_time
     end_time: $end_time
     actual_start_time: $actual_start_time
     actual_end_time: $actual_end_time
     activity_description:$activity_description
     workshop_id: $workshop_id
     created_by: $createdUserToken
     workshop_day : $workshop_day
     duration: $duration
     activity_id: $activity_id
     activity_tag:$activity_tag
     status: $status
   }) {
     activity_id
     activity_description
     workshop_id
     status
     activity_tag
   }
 }`;

  createWorkshopResponse = `mutation updateWorkShopResponse($userId: ID!, $workshopId: ID, $activityID: ID, $response: String){
         createWorkShopResponse(input: {
           user_id: $userId
           workshop_id: $workshopId
           activity_id: $activityID
           response: $response
         }) {
           data
         }
       }
       `;

  saveWorkshopFinalResponse =
    `mutation updateWorkShopFinalResponse($userId: ID!, $workshopId: ID, $activityID: ID, $response: String, $status: ID!){
         createWorkShopFinalResponse(input: {
           user_id: $userId
           workshop_id: $workshopId
           activity_id: $activityID
           response: $response
           status: $status
         }) {
           data
         }
       }`;

  deleteWorkshopUserResponse = `mutation deleteWorkshopUserResponse($responseId: ID!) {
         deleteWorkUserResponse(
           response_id :$responseId
         ){
         data
         }
     }`;

  updateWorkshopUserResponse = `mutation updateWorkUserResponse($userId: ID!,
         $workshopId: ID, $activityId: ID, $response: String, $responseId: ID!) {
       updateWorkUserResponse(input: {
         user_id: $userId
         workshop_id: $workshopId
         activity_id: $activityId
         response: $response
         response_id: $responseId
       }){
       data
       }
   }`;

  createRisk = `mutation createRisk($ORG_ID: Int, $CATEGORY: String!, $CLOSURE_DATE: String!, $COMMENTS: String, $CONTINGENCY_PLAN: String, $CREATED_BY: String, $CREATED_DATE: String, $DESCRIPTION: String!, $IMPACT: String, $IMPACT_PROBABILITY: Int, $MITIGATION_PLAN: String, $OCCURRENCE_LIKELIHOOD: Int, $OWNER: String!, $PROJECT_ID: Int!, $RISK_IMPACT: String!, $RISK_PRIORITY_NUMBER: Int!, $STAGE: String!, $STATUS: String!, $TOWER: String!, $UPDATED_BY: String) {
    createRisk(body: {PROJECT_ID: $PROJECT_ID, TOWER: $TOWER, CATEGORY: $CATEGORY, DESCRIPTION: $DESCRIPTION, RISK_IMPACT: $RISK_IMPACT, OWNER: $OWNER, STATUS: $STATUS, CLOSURE_DATE: $CLOSURE_DATE, STAGE: $STAGE, COMMENTS: $COMMENTS, CONTINGENCY_PLAN: $CONTINGENCY_PLAN, CREATED_BY: $CREATED_BY, CREATED_DATE: $CREATED_DATE, IMPACT: $IMPACT, IMPACT_PROBABILITY: $IMPACT_PROBABILITY, MITIGATION_PLAN: $MITIGATION_PLAN, OCCURRENCE_LIKELIHOOD: $OCCURRENCE_LIKELIHOOD, ORG_ID: $ORG_ID, RISK_PRIORITY_NUMBER: $RISK_PRIORITY_NUMBER, UPDATED_BY: $UPDATED_BY}) {
      data
    }
  }`;
  updateRisk = `mutation updateRisk($CATEGORY: String!, $CLOSURE_DATE: String!, $COMMENTS: String, $CONTINGENCY_PLAN: String, $CREATED_BY: String, $CREATED_DATE: String, $DESCRIPTION: String!, $IMPACT: String, $IMPACT_PROBABILITY: Int, $MITIGATION_PLAN: String, $OCCURRENCE_LIKELIHOOD: Int, $ORG_ID: Int, $OWNER: String!, $PROJECT_ID: Int!, $RISK_IMPACT: String!, $RISK_PRIORITY_NUMBER: Int!, $STAGE: String!, $STATUS: String!, $TOWER: String!, $UPDATED_BY: String, $ID: Int) {
    updateRisk(body: {CATEGORY: $CATEGORY, CLOSURE_DATE: $CLOSURE_DATE, COMMENTS: $COMMENTS, CONTINGENCY_PLAN: $CONTINGENCY_PLAN, CREATED_BY: $CREATED_BY, CREATED_DATE: $CREATED_DATE, DESCRIPTION: $DESCRIPTION, IMPACT: $IMPACT, IMPACT_PROBABILITY: $IMPACT_PROBABILITY, MITIGATION_PLAN: $MITIGATION_PLAN, OCCURRENCE_LIKELIHOOD: $OCCURRENCE_LIKELIHOOD, ORG_ID: $ORG_ID, OWNER: $OWNER, PROJECT_ID: $PROJECT_ID, RISK_IMPACT: $RISK_IMPACT, RISK_PRIORITY_NUMBER: $RISK_PRIORITY_NUMBER, STAGE: $STAGE, STATUS: $STATUS, TOWER: $TOWER, UPDATED_BY: $UPDATED_BY, ID: $ID}) {
      data
    }
  }`;

  deleteRisk = `mutation deleteRisk($risk_id: Int!) {
    deleteRisk(risk_id: $risk_id) {
      data
  }
}`;

  // assumptions
  createAssumption = `mutation createAssumption($ORG_ID: Int, $COMMENTS: String, $CREATED_BY: String, $CREATED_DATE: String, $DESCRIPTION: String!, $IMPACT: String, $PROJECT_ID: Int!, $STAGE: String!, $STATUS: String!, $REASON: String, $ACTION_TO_VALIDATE: String, $TOWER: String!, $UPDATED_BY: String, $UPDATED_DATE: String) {
    createAssumption(body: {PROJECT_ID: $PROJECT_ID, TOWER: $TOWER, DESCRIPTION: $DESCRIPTION,  STATUS: $STATUS, ACTION_TO_VALIDATE: $ACTION_TO_VALIDATE, STAGE: $STAGE, COMMENTS: $COMMENTS, CREATED_BY: $CREATED_BY, REASON: $REASON, CREATED_DATE: $CREATED_DATE, IMPACT: $IMPACT, ORG_ID: $ORG_ID, UPDATED_BY: $UPDATED_BY, UPDATED_DATE: $UPDATED_DATE}) {
    data
  }
}`;

  updateAssumption = `mutation updateAssumption($ORG_ID: Int, $COMMENTS: String, $CREATED_BY: String, $CREATED_DATE: String, $DESCRIPTION: String!, $IMPACT: String, $PROJECT_ID: Int!, $STAGE: String!, $STATUS: String!, $REASON: String, $ACTION_TO_VALIDATE: String, $TOWER: String!, $UPDATED_BY: String, $UPDATED_DATE: String, $ID: Int) {
    updateAssumption(body: {PROJECT_ID: $PROJECT_ID, TOWER: $TOWER, DESCRIPTION: $DESCRIPTION,  STATUS: $STATUS, ACTION_TO_VALIDATE: $ACTION_TO_VALIDATE, STAGE: $STAGE, COMMENTS: $COMMENTS, CREATED_BY: $CREATED_BY, REASON: $REASON, CREATED_DATE: $CREATED_DATE, IMPACT: $IMPACT, ORG_ID: $ORG_ID, UPDATED_BY: $UPDATED_BY, UPDATED_DATE: $UPDATED_DATE, ID: $ID}) {
    data
  }
}`;

  deleteAssumption = `mutation deleteAssumption($assumption_id: Int!) {
    deleteAssumption(assumption_id: $assumption_id) {
    data
}
}`;

  // issues
  createIssue = `mutation createIssue($ORG_ID: Int, $COMMENTS: String, $CREATED_BY: String, $CREATED_DATE: String, $DESCRIPTION: String!, $MITIGATION_PLAN: String, $ASSIGNED_TO: String, $PROJECT_ID: Int!, $STAGE: String!, $STATUS: String!, $RAISED_BY: String, $SEVERITY: String, $PLANNED_CLOSURE_DATE: String, $ACTUAL_CLOSURE_DATE: String, $TOWER: String!, $UPDATED_BY: String,  $UPDATED_DATE: String) {
    createIssue(body: {PROJECT_ID: $PROJECT_ID, TOWER: $TOWER, DESCRIPTION: $DESCRIPTION, SEVERITY: $SEVERITY, STATUS: $STATUS, STAGE: $STAGE, COMMENTS: $COMMENTS, CREATED_BY: $CREATED_BY, RAISED_BY: $RAISED_BY,PLANNED_CLOSURE_DATE: $PLANNED_CLOSURE_DATE, ACTUAL_CLOSURE_DATE: $ACTUAL_CLOSURE_DATE, CREATED_DATE: $CREATED_DATE, MITIGATION_PLAN: $MITIGATION_PLAN, ASSIGNED_TO: $ASSIGNED_TO, ORG_ID: $ORG_ID, UPDATED_BY: $UPDATED_BY, UPDATED_DATE: $UPDATED_DATE}) {
    data
  }
}`;

  updateIssue = `mutation updateIssue( $COMMENTS: String, $CREATED_BY: String, $PLANNED_CLOSURE_DATE: String, $CREATED_DATE: String, $DESCRIPTION: String!, $MITIGATION_PLAN: String, $RAISED_BY: String,$ASSIGNED_TO: String, $ORG_ID: Int,  $PROJECT_ID: Int!, $STAGE: String!, $STATUS: String!, $TOWER: String!, $SEVERITY: String, $ACTUAL_CLOSURE_DATE: String, $UPDATED_BY: String,$UPDATED_DATE: String, $ID: Int) {
  updateIssue(body: { COMMENTS: $COMMENTS, CREATED_BY: $CREATED_BY, ASSIGNED_TO: $ASSIGNED_TO,PLANNED_CLOSURE_DATE: $PLANNED_CLOSURE_DATE, CREATED_DATE: $CREATED_DATE, DESCRIPTION: $DESCRIPTION, MITIGATION_PLAN: $MITIGATION_PLAN, SEVERITY: $SEVERITY, ORG_ID: $ORG_ID, PROJECT_ID: $PROJECT_ID, RAISED_BY: $RAISED_BY,ACTUAL_CLOSURE_DATE: $ACTUAL_CLOSURE_DATE, STAGE: $STAGE, STATUS: $STATUS, TOWER: $TOWER, UPDATED_BY: $UPDATED_BY, UPDATED_DATE: $UPDATED_DATE, ID: $ID}) {
    data
  }
}`;

  deleteIssue = `mutation deleteIssue($issue_id: Int!) {
  deleteIssue(issue_id: $issue_id) {
    data
}
}`;

  // decisions
  createDecision = `mutation createDecision($ORG_ID: Int,  $COMMENTS: String, $CLOSED_DATE: String, $CREATED_BY: String, $CREATED_DATE: String, $DESCRIPTION: String!, $DUE_DATE: String, $PRIORITY: String, $OWNER: String!, $PROJECT_ID: Int!, $STAGE: String!, $STATUS: String!, $DEPENDENT_DELIVERABLE: String, $TOWER: String!, $UPDATED_BY: String, $UPDATED_DATE: String) {
  createDecision(body: {PROJECT_ID: $PROJECT_ID, TOWER: $TOWER, DESCRIPTION: $DESCRIPTION, OWNER: $OWNER, DUE_DATE: $DUE_DATE, STATUS: $STATUS, STAGE: $STAGE, COMMENTS: $COMMENTS, CREATED_BY: $CREATED_BY, DEPENDENT_DELIVERABLE: $DEPENDENT_DELIVERABLE, CREATED_DATE: $CREATED_DATE, PRIORITY: $PRIORITY,CLOSED_DATE: $CLOSED_DATE,UPDATED_DATE: $UPDATED_DATE, ORG_ID: $ORG_ID, UPDATED_BY: $UPDATED_BY}) {
    data
  }
}`;

  updateDecision = `mutation updateDecision($COMMENTS: String, $CREATED_BY: String, $DUE_DATE: String, $CREATED_DATE: String, $DESCRIPTION: String!, $ORG_ID: Int, $DEPENDENT_DELIVERABLE: String,$CLOSED_DATE: String, $OWNER: String!, $PROJECT_ID: Int!, $STAGE: String!, $STATUS: String!, $TOWER: String!, $PRIORITY: String, $UPDATED_DATE: String, $UPDATED_BY: String, $ID: Int) {
  updateDecision(body: { COMMENTS: $COMMENTS, CREATED_BY: $CREATED_BY, DUE_DATE: $DUE_DATE, PRIORITY: $PRIORITY, CREATED_DATE: $CREATED_DATE, DESCRIPTION: $DESCRIPTION, DEPENDENT_DELIVERABLE: $DEPENDENT_DELIVERABLE, ORG_ID: $ORG_ID, OWNER: $OWNER, PROJECT_ID: $PROJECT_ID,CLOSED_DATE: $CLOSED_DATE,UPDATED_DATE: $UPDATED_DATE, STAGE: $STAGE, STATUS: $STATUS, TOWER: $TOWER, UPDATED_BY: $UPDATED_BY, ID: $ID}) {
    data
  }
}`;

  deleteDecision = `mutation deleteDecision($decision_id: Int!) {
  deleteDecision(decision_id: $decision_id) {
    data
}
}`;

  createProjectStory = `mutation createProjectStory($input:AWSJSON!) {
      createProjectStory(input:$input){
        data
     }
 }`;
  updateProjectStory = `mutation updateProjectStory($input:AWSJSON!) {
  updateProjectStory(input: $input) {
    data
  }
 }`;

  uploadStoryImage = `mutation uploadStoryImage($query: UploadStoryImageInput!) {
  uploadStoryImage(query: $query) {
    data
  }
 }`;

  updateUserData = `mutation updateUserData($user_id: Int, $expected_start_date: String, $expected_end_date: String, $actual_start_date: String,
	$actual_end_date: String, $advisor: String) {
  updateUserData(body: { user_id: $user_id, expected_start_date: $expected_start_date, expected_end_date: $expected_end_date, actual_start_date: $actual_start_date, actual_end_date: $actual_end_date, advisor: $advisor}) {
    data
  }
}`;

  saveProjectConfig = `mutation createProjectNotification($DESCRIPTION: String, $PROJECT_ID: Int!, $DAYS_TILL_TRIGGER: Int!, $ALERT_TYPE: String!, $EVENT_NAME: String!, $EMAIL_IDS: String!, $CREATED_DATE: String!, $CREATED_BY: Int!, $ORG_ID: Int!, $UPDATED_BY: Int!, $UPDATED_DATE: String!, $USER_ROLE: String!, $USER_ID: Int!, $ALERT_DATE: String!) {
  createProjectNotification(body: {DESCRIPTION: $DESCRIPTION, PROJECT_ID: $PROJECT_ID, DAYS_TILL_TRIGGER: $DAYS_TILL_TRIGGER, ALERT_TYPE: $ALERT_TYPE, EVENT_NAME: $EVENT_NAME, EMAIL_IDS: $EMAIL_IDS, CREATED_DATE: $CREATED_DATE, CREATED_BY: $CREATED_BY, ORG_ID: $ORG_ID, UPDATED_BY: $UPDATED_BY, UPDATED_DATE: $UPDATED_DATE, USER_ROLE: $USER_ROLE, USER_ID: $USER_ID, ALERT_DATE: $ALERT_DATE}) {
    data
  }
}`;
  updateProjectConfig = ``;
  deleteProjectConfig = ``;

  createProjectRelease = `mutation createProjectRelease($input:AWSJSON!) {
      createProjectRelease(input: $input){
        data
     }
 }`;

  updateProjectRelease = `mutation updateProjectRelease($input:AWSJSON!) {
  updateProjectRelease(input: $input) {
    data
  }
 }`;

  deleteProjectRelease = `mutation deleteProjectRelease(id: Int!) {
    deleteProjectRelease(objectId: $id) {
      data
  }
}`;

}
